package com.sweetlime.bingeamigo.presentation.features.follow

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.model.types.FollowType
import com.sweetlime.bingeamigo.presentation.features.profile.ProfileViewModel
import com.sweetlime.bingeamigo.presentation.features.user.UserProfileScreen
import org.koin.compose.koinInject

data class FollowListScreen(
    val type: FollowType
) : Screen {
    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel: ProfileViewModel = koinInject()
        val followers by viewModel.followers.collectAsState()
        val following by viewModel.following.collectAsState()
        val profiles = if (type == FollowType.FOLLOWERS) followers else following
        
        LaunchedEffect(Unit) {

            when(type) {

                FollowType.FOLLOWERS -> {
                    viewModel.loadFollowers()
                }

                FollowType.FOLLOWING -> {
                    viewModel.loadFollowing()
                }
            }
        }
        
        FollowListContent(
            type, {
                navigator.pop()
            },
            { userId ->
                navigator.push(UserProfileScreen(userId))
            },
            profiles = profiles
        )
    }
}